import { Timestamp } from "firebase/firestore";

export const PLACE_NOTE_COLLECTION = "placeNotes";

export interface PlaceNoteDocument {
  id: string;
  placeId: string;
  creatorId: string;
  noteText: string;
  createdAt: Timestamp;
  updatedAt: Timestamp;
  // Voting
  upvotes: number;
  downvotes: number;
  voterUserIds: string[];
  // Denormalized fields:
  creatorUsername: string;
  creatorProfilePictureUrl: string;
  placeName: string;
}

export interface PlaceNote {
  id: string;
  placeId: string;
  creatorId: string;
  noteText: string;
  createdAt: Timestamp;
  updatedAt: Timestamp;
  // Voting
  upvotes: number;
  downvotes: number;
  voterUserIds: string[];
  // Denormalized fields:
  creatorUsername?: string;
  creatorProfilePictureUrl?: string;
  placeName?: string;
}
